<template>
  <!-- Template code goes here. Remember that a template always has to have 1 main wrapper, that is why we start with an empty div. -->
  <div class="full-screen-cookie-popup">
    <div class="full-screen-cookie-popup__overlay">

    </div>
    <div class="full-screen-cookie-popup__wrapper">
      <div class="full-screen-cookie-popup__popup">
        <div class="full-screen-cookie-popup__popup__top">
          <img :src="settings.logo">
        </div>
        <div class="full-screen-cookie-popup__popup__content">
          <div class="full-screen-cookie-popup__popup__content__title">
            {{ popupTitle }}
          </div>
          <div class="full-screen-cookie-popup__popup__content__desc">
            {{ simpleDescription }}
          </div>
        </div>
        <div class="full-screen-cookie-popup__popup__bottom">
          <div class="full-screen-cookie-popup__popup__bottom__button no-select" @click="acceptCookie('simple')">
            <p>{{ translations['gdpr.allow'] }}</p>
          </div>
          <div class="full-screen-cookie-popup__popup__bottom__link">
            {{ translations['gdpr.learn_more'] }} <a href="../about/policies/privacy-policy" target="_blank">Privacy
            Policy.</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import CookieMixin from '../mixins/CookieMixin.js'
import CookieMixin from '../../mixins/CookieMixin.js';

export default {
  mixins: [CookieMixin],
  name: 'blocking-popup',

}
</script>

<style lang="scss" scoped>
.full-screen-cookie-popup {
  $self: &;

  &__overlay {
    transition: background 0.3s ease-in-out;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9996;
    background: rgba(#222, 0.8);
  }

  &__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9997;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__popup {
    margin-top: -100px;
    opacity: 1;
    transform: translateY(0px);
    transition: transform 0.3s ease-out, opacity 0.3s ease-out;
    min-height: 250px;
    width: 500px;
    background: #fff;
    box-shadow: 0 14px 28px rgba(82, 80, 80, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    border-radius: 5px !important;

    &__top {
      border-radius: 5px 5px 0 0 !important;
      text-align: center;
      width: 100%;
      padding: 22px;
      background: #ffc109;

      img {
        max-width: 200px;

        @media (max-width: 550px) {
          max-width: 150px;
        }
      }
    }

    &__content {
      padding: 30px;
      text-align: center;

      &__title {
        font-weight: 600;
        font-size: 16px;
        color: #545454;
        margin-bottom: 15px;
      }

      &__desc {
        line-height: 25px;
        color: #6f6f6f;
      }

      @media (max-width: 550px) {
        max-height: 250px;
        padding: 22px;

        &__title {
          margin-bottom: 10px;
        }

        &__desc {
          line-height: 22px;
        }
      }
    }

    &__bottom {
      border-radius: 0 0 5px 5px !important;
      padding: 40px;
      padding-top: 20px;
      padding-bottom: 20px;
      background: #f9f9f9;
      text-align: center;

      &__button {
        transition: opacity 0.2s ease-in-out;
        display: inline-block;
        background: #3c9e3c;
        color: #fff;
        padding: 12px;
        border-radius: 3px !important;
        font-weight: 600;
        padding-left: 45px;
        padding-right: 45px;
        border-bottom: 3px solid #2b6f2b;

        p {
          color: #fff !important;
          margin: 0;
        }

        &:hover {
          cursor: pointer;
          opacity: 0.8;
        }
      }

      &__link {
        display: block;
        font-size: 12px;
        color: #adadad;
        margin-top: 10px;

        a {
          color: gray;
          text-decoration: underline;
        }
      }
    }

    @media(max-width: 767px) {
      margin-top: 0;
    }

    @media(max-width: 550px) {
      width: 95%;
    }
  }
}
</style>